module.exports = __webpack_public_path__ + "static/media/9DESA19.678b0712.jpg";